jQuery(function ($){

  dropdown(
    $('.project-info__content'),
    $('.project-info__dropdown'),
    $('.project-info__dropdown-icon')
  )

  dropdown(
    $('.filters__content'),
    $('.filters__heading'),
    $('.filters__icon')
  )

  function dropdown (content, btn, icon) {

    btn.on('click', function() {

      if(content.hasClass('shown')) {

        content.removeClass('shown').addClass('active').slideUp();
        icon.removeClass('shown');

      } else {

        content.addClass('shown').slideDown();
        icon.addClass('shown');
      }

    });

  }

});